import React from "react";
import HomeComponent from "../../components/homeComponents/HomeComponent";

export interface HomeContainerProps {
    isTabSelected: boolean
}

const HomeContainer: React.FC<HomeContainerProps> = ({isTabSelected}) => {
    return (
        <HomeComponent
            isTabSelected={isTabSelected}
        />
    )
};

export default HomeContainer;
